import PropTypes from 'prop-types'
import {isValidElement} from 'react'

export function FormFieldGroup(props){
    return(
        <div className={`form-field-group ${props.className ? props.className : ""}`}>
            {isValidElement(props.title) ? props.title : 
            (<p className="title">
                {props.title}
            </p>)}
            <div className="input-container">
                {props.children}
            </div>
            {props.errorElement && props.errorElement}
        </div>
    )

}

FormFieldGroup.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
    className: PropTypes.string,
    errorElement: PropTypes.oneOfType([PropTypes.bool,PropTypes.node]) 
}

export default FormFieldGroup